import axios from 'axios';

export const isOAuthEnabled = () => true;

export const buildAuthorizeUrl = () => '/api/oauth/authorize';

export const fetchCurrentUser = async () => {
  const res = await axios.get('/api/me');
  return res.data;
};

export const loginWithPassword = async ({ email, password }) => {
  const res = await axios.post('/api/login', { email, password });
  return res.data;
};

export const logoutOAuth = async () => {
  const res = await axios.post('/api/logout');
  return res.data;
};

export const refreshAuth = async () => {
  const res = await axios.post('/api/refresh');
  return res.data;
};
